var RegionName;
(function (RegionName) {
    RegionName["THE_BRONX"] = "The Bronx";
    RegionName["BROOKLYN"] = "Brooklyn";
    RegionName["CONNECTICUT"] = "Connecticut";
    RegionName["HUDSON_VALLEY"] = "Hudson Valley";
    RegionName["LONG_ISLAND"] = "Long Island";
    RegionName["NEW_JERSEY"] = "New Jersey";
    RegionName["NEW_YORK"] = "New York";
    RegionName["WESTCHESTER"] = "Westchester";
    RegionName["DEFAULT"] = "Default";
})(RegionName || (RegionName = {}));

export { RegionName };
//# sourceMappingURL=region.mjs.map
